import React from 'react';
import PropTypes from 'prop-types';

const UploadProgressBar = ({ progress }) => {
  return (
    <div className="progress-bar-container">
      <div className="progress-header">
        <span>{progress < 100 ? "Uploading..." : "Upload Complete!"}</span>
        <span>{progress}%</span>
      </div>
      <div className="progress-bar">
        <div className="progress-bar-fill" style={{ width: `${progress}%` }}></div>
      </div>
    </div>
  );
};

UploadProgressBar.propTypes = {
  progress: PropTypes.number.isRequired,
};

export { UploadProgressBar };
